export const SESSION_DETAILS = 
[
    {
        "id": 0,
        "teacherId": 1135,
        "classId":0,
        "modId":5,
        "title": "How does the type of soil affect the drainage of water through soil",
        "groupType": "Homogeneous",
        "groupSize":4,
        "groups":[
            {
            "groupId":1,
            "currentStatus":"Hypothesis"
            },
            {
              "groupId":2,
              "currentStatus":"Experiment"
            },
            {
              "groupId":3,
              "currentStatus":"Board"
            }
            ,
            {
              "groupId":4,
              "currentStatus":"Forum"
            }
            ,
            {
              "groupId":5,
              "currentStatus":"ReportWriting"
            }
            ,
            {
              "groupId":6,
              "currentStatus":"PeerReview"
            }
        ] ,
        "completed":false,
        "start": "2020-11-20T10:29:00.000Z"
    },
    {
        "id": 1,
        "teacherId": 1145,
        "classId":0,
        "modId":6,
        "title": "Factors that affect the swing of pendulum: mass of object at the end",
        "groupType": "Heterogeneous",
        "groupSize":4,
        "groups":[
            {
            "groupId":1,
            "currentStatus":"Hypothesis"
            },
            {
              "groupId":2,
              "currentStatus":"Experiment"
            },
            {
              "groupId":3,
              "currentStatus":"Board"
            }
            ,
            {
              "groupId":4,
              "currentStatus":"Forum"
            }
            ,
            {
              "groupId":5,
              "currentStatus":"ReportWriting"
            }
            ,
            {
              "groupId":6,
              "currentStatus":"PeerReview"
            }
        ] ,
        "completed":false,
        "start": "2020-11-22T8:29:00.000Z"
    }
   
    
    
    
];